export const NAV_ICONS = {
  backfill: 'function-add',
  catalog: 'book-2',
  connectionSettings: 'plug',
  dataProducts: 'server',
  healthDashboard: 'heart-pulse',
  navigator: 'bubble-chart',
  notifications: 'notification-2',
  organizations: 'building-4',
  settings: 'settings-3',
  studio: 'artboard',
  users: 'group',
};

export const NAV_ROUTES = Object.freeze({
  backfill: { name: 'backfill' },
  catalog: { name: 'catalog' }, // go to families until we have a design for the catalog landing page
  connectionSettings: { name: 'connection-settings' },
  dashboard: { name: 'dashboard' },
  dataProducts: { name: 'data-products' },
  discoverSuppliers: { name: 'discover-suppliers' },
  healthDashboard: { name: 'health-dashboard' },
  navigator: { name: 'navigator' },
  notifications: { name: 'notifications' },
  organizations: { name: 'orgs' },
  settings: { name: 'settings' },
  studio: { name: 'studio-data-products-create' },
  users: { name: 'users' },
});

export const NOTIFICATIONS_ICONS = {
  channels: 'broadcast',
  preferences: 'equalizer',
  rules: 'article',
};

export const NOTIFICATIONS_ROUTES = {
  channels: 'notifications-channels',
  preferences: 'notifications-preferences',
  rules: 'notifications-rules',
};

export const SETTINGS_ICONS = {
  apiKeys: 'key',
  general: 'settings-3',
  planAndBilling: 'bank-card-2',
  usage: 'bar-chart-box',
};

export const SETTINGS_ROUTES = {
  apiKeys: 'settings-api-keys',
  general: 'settings-general',
  planAndBilling: 'settings-plan-details',
  upgrade: 'settings-plan-details-upgrade',
  usage: 'settings-usage',
  yourPlan: 'settings-plan-details-your-plan',
};
